import { useState } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Tippy from '@tippyjs/react';
import '../TrackMenu/TrackMenu.scss';
import { ProductViewModes } from '@/utils/productStateUtils';

interface VolumeProp {
  showRemovebutton: boolean;
  onAddClickHandler: any;
  volumeNumner: number;
  usesSides: boolean;
  productViewMode?: ProductViewModes;
}
const VolumeMenu = (props: VolumeProp) => {
  const [visible, setVisible] = useState(false);
  const show = () => setVisible(true);
  const hide = () => setVisible(false);
  const { t } = useTranslation();
  const isChangeRequestMode =
    props.productViewMode === ProductViewModes.ChangeRequest;

  const formatNewLabel = (usesSides: boolean): string => {
    return usesSides
      ? t('product.editProduct.newSide')
      : t('product.editProduct.newDisc');
  };

  const formatRemoveLabel = (usesSides: boolean): string => {
    return usesSides
      ? t('product.editProduct.removeSide')
      : t('product.editProduct.removeDisc');
  };

  const dropDownContent = (
    <div className="menu-container">
      <div onClick={() => onClickHandler('add')} className="menu-item">
        <span className="icon fas fa-plus blue-color"></span>
        <span className="item-text">{formatNewLabel(props.usesSides)}</span>
      </div>
      {props.showRemovebutton ? (
        <div onClick={() => onClickHandler('remove')} className="menu-item">
          <span className="icon fas fa-times blue-color"></span>
          <span className="item-text">
            {formatRemoveLabel(props.usesSides)}
          </span>
        </div>
      ) : null}
    </div>
  );

  const onClickHandler = (option: any) => {
    hide();

    if (option === 'add') {
      props.onAddClickHandler(option, props.volumeNumner);
    }

    if (option === 'remove') {
      props.onAddClickHandler(option, props.volumeNumner);
    }
  };

  return (
    <>
      {' '}
      {!isChangeRequestMode ? (
        <Tippy
          content={dropDownContent}
          visible={visible}
          onClickOutside={hide}
          allowHTML={true}
          arrow={false}
          appendTo={document.body}
          interactive={true}
          placement="left"
        >
          <span
            className="icon fas fa-ellipsis-v action-menu-icon volume-span"
            onClick={visible ? hide : show}
          ></span>
        </Tippy>
      ) : null}
    </>
  );
};

export default VolumeMenu;
